import { render, staticRenderFns } from "./ProductSet.vue?vue&type=template&id=6bb82c04&"
import script from "./ProductSet.vue?vue&type=script&lang=js&"
export * from "./ProductSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports